import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllOrders } from 'src/redux/orders'
import {
  CTable,
  CTableHead,
  CTableBody,
  CTableRow,
  CTableHeaderCell,
  CTableDataCell,
  CCardBody,
  CSpinner,
  CImage,
} from '@coreui/react'

const Allorders = () => {
  const dispatch = useDispatch()
  const { allOrders, loading, error } = useSelector((state) => state.orders)

  useEffect(() => {
    dispatch(getAllOrders())
  }, [dispatch])

  if (loading) return <CSpinner color="primary" className="d-block mx-auto my-4" />
  if (error) return <p className="text-danger text-center">Error: {error}</p>
  if (!allOrders || allOrders.length === 0) return <p className="text-center">No orders found</p>

  return (
    // <CCard>
    <CCardBody>
      <CTable hover responsive bordered>
        <CTableHead color="dark">
          <CTableRow>
            <CTableHeaderCell>#</CTableHeaderCell>
            <CTableHeaderCell>Order No</CTableHeaderCell>
            <CTableHeaderCell>Status</CTableHeaderCell>
            <CTableHeaderCell>Total Amount</CTableHeaderCell>
            <CTableHeaderCell>Delivery Charges</CTableHeaderCell>
            <CTableHeaderCell>Coupons Discount</CTableHeaderCell>
            <CTableHeaderCell>Payment Method</CTableHeaderCell>
            <CTableHeaderCell>Order Date</CTableHeaderCell>
            <CTableHeaderCell>Delivery Slot</CTableHeaderCell>
            <CTableHeaderCell>Billing Address</CTableHeaderCell>
            <CTableHeaderCell>Shipping Address</CTableHeaderCell>
            <CTableHeaderCell>Customer</CTableHeaderCell>
            <CTableHeaderCell>Product</CTableHeaderCell>
            <CTableHeaderCell>Quantity</CTableHeaderCell>
            <CTableHeaderCell>Weight</CTableHeaderCell>
            <CTableHeaderCell>Pieces</CTableHeaderCell>
            <CTableHeaderCell>Price</CTableHeaderCell>
            <CTableHeaderCell>Product Image</CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {allOrders.map((order, index) => (
            <CTableRow key={order.id}>
              <CTableDataCell>{index + 1}</CTableDataCell>
              <CTableDataCell>{order.order_no}</CTableDataCell>
              <CTableDataCell>{order.order_status}</CTableDataCell>
              <CTableDataCell>₹{order.total_amount}</CTableDataCell>
              <CTableDataCell>₹{order.delivery_charges}</CTableDataCell>
              <CTableDataCell>₹{order.coupons_discount}</CTableDataCell>
              <CTableDataCell>{order.payment_method}</CTableDataCell>
              <CTableDataCell>{new Date(order.order_date).toLocaleDateString()}</CTableDataCell>
              <CTableDataCell>
                {order.date_slot} ({order.time_slot})
              </CTableDataCell>
              <CTableDataCell>{order.billing_address}</CTableDataCell>
              <CTableDataCell>{order.shipping_address}</CTableDataCell>
              <CTableDataCell>
                {order.full_name} ({order.mobile_no})
              </CTableDataCell>
              <CTableDataCell>{order.product_name}</CTableDataCell>
              <CTableDataCell>{order.quantity}</CTableDataCell>
              <CTableDataCell>{order.product_weight}</CTableDataCell>
              <CTableDataCell>{order.product_pieces}</CTableDataCell>
              <CTableDataCell>₹{order.product_price}</CTableDataCell>
              <CTableDataCell>
                <CImage src={order.product_images} width={50} height={50} thumbnail />
              </CTableDataCell>
            </CTableRow>
          ))}
        </CTableBody>
      </CTable>
    </CCardBody>
    // </CCard>
  )
}

export default Allorders
